/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Declinedeal_Gpdeclinereasonrequired5Inputs */

const en_coinvestments_declinedeal_gpdeclinereasonrequired5 = /** @type {(inputs: Coinvestments_Declinedeal_Gpdeclinereasonrequired5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select a reason`)
};

/**
* | output |
* | --- |
* | "Please select a reason" |
*
* @param {Coinvestments_Declinedeal_Gpdeclinereasonrequired5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_declinedeal_gpdeclinereasonrequired5 = /** @type {((inputs?: Coinvestments_Declinedeal_Gpdeclinereasonrequired5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Declinedeal_Gpdeclinereasonrequired5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_declinedeal_gpdeclinereasonrequired5(inputs)
});
export { coinvestments_declinedeal_gpdeclinereasonrequired5 as "coInvestments_declineDeal_gpDeclineReasonRequired" }